import {
    SKU_EXITS_ERP_SUCCESS,
    SKU_EXITS_ERP_REQUEST,
    SKU_EXITS_ERP_ERROR,

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case SKU_EXITS_ERP_REQUEST:
            return {
                loading: true,
            };
        case SKU_EXITS_ERP_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case SKU_EXITS_ERP_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}